import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../store/slices/authentication";
import { SharedHorizontalTabs } from "../../shared";
import BlockedFeatureBanner from "../../shared/BlockedFeatureBanner";
import MarketplaceItems from "./Items";
import CreateItem from "./CreateItem";

// "Landing" was removed: its welcome copy now lives as a collapsible intro on the
// Browse Items tab, so opening the Marketplace shows live listings, not static text.
// Old ?tab=landing links fall through to index 0 (Browse Items) via useGetTabIndex.
const TABS = [
  { key: "items", label: "Browse Items" },
  { key: "createItem", label: "Post Item" },
];

function Marketplace() {
  const user = useSelector(selectUser);
  const individualId = user?.externalId ? parseInt(user.externalId) : null;
  const { currentTabIndex, setSearchParams } =
    SharedHorizontalTabs.useGetTabIndex(TABS);

  const handleTabChange = (index) => {
    setSearchParams({ tab: TABS[index].key }, { replace: true });
  };

  // Switch on the tab KEY, not its position, so reordering or removing a tab
  // can never silently render the wrong panel.
  const renderTabContent = () => {
    switch (TABS[currentTabIndex]?.key) {
      case "createItem":
        return <CreateItem />;
      case "items":
      default:
        return <MarketplaceItems />;
    }
  };

  return (
    <BlockedFeatureBanner
      featureKey="is_marketplace_blocked"
      featureName="Marketplace"
      individualId={individualId}
      mode="full"
    >
      <div className="min-h-screen flex flex-col px-4 md:px-[60px] py-[30px] gap-y-[40px] bg-dupontCream dark:bg-darkPrimary transition-colors duration-200">
        <div className="flex flex-col items-center">
          <div className="flex flex-col items-center text-center">
            <h1 className="text-[42px] font-display font-bold text-dupontBlue dark:text-darkText mb-[12px]">
              Marketplace
            </h1>
            <div className="w-[80px] h-[1px] bg-dupontGold"></div>
          </div>
        </div>
        <div className="flex flex-col gap-y-[30px]">
          <SharedHorizontalTabs.Component
            tabs={TABS.map((tab) => tab.label)}
            initialIndex={currentTabIndex}
            onChange={handleTabChange}
          />
          {renderTabContent()}
        </div>
      </div>
    </BlockedFeatureBanner>
  );
}

export default Marketplace;
